import { makeStyles, Theme } from '@material-ui/core';
const useStyles = makeStyles<Theme>(theme => ({
  h100: {
    height: '100%',
  },
  refreshButton: {
    '&:hover': {
      backgroundColor: theme.palette.common.blue400,
      color: theme.palette.common.white,
    },
    backgroundColor: theme.palette.common.brandTint,
    boxShadow: 'unset',
    color: theme.palette.common.blue400,
  },
  w100: {
    width: '100%',
  },
}));

export default useStyles;
